import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Swiper, SwiperSlide } from "swiper/react";
import SwiperCore, { Navigation, } from "swiper";
import { useRef } from "react";
import { ChevronRight, ChevronLeft } from "@material-ui/icons";
import AllofferCard from "Utills/AllofferCard";
import axios from "axios";
import Loader from "Components/others/Loader";
import CustomModal from "Utills/Model/CustomModel";
import { useNotifyContext } from "context/notifyContext"

// swiper slider configs
SwiperCore.use([Navigation]);

// user token
let storeData = localStorage.getItem("cyan_user");
let userToken = storeData ? JSON.parse(storeData) : ""
// api endpoints
let api_domain =  process.env.REACT_APP_API_DOMAIN;
let allInclusive_API =  process.env.REACT_APP_ALL_INCLUSIVE_OFFERS_ADMIN;

const AllInCLusivePage = () => {
    const { set_notify, loading, set_loader } = useNotifyContext()
    let [activeTab, setActiveTab] = useState(0);
    const [loaded, setLoaded] = useState(false);
    const [offersData, setOfferData] = useState([]);
    const [filtered, setFiltered] = useState([]);
    const [data_intraday, setDataIntraday] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);
    const [searching, setSearching] = useState(false);
    const [searching_intra, set_searching_intra] = useState(false);
    const [searchedData, setSearchedData] = useState([]);
    const [searchedData_intra, set_searchedData_intra] = useState([]);
    const [askModal, setAskModal] = useState(false);
    const [selectedOffer, setSelected] = useState(null);

    // =========== all tabs data ==================
    let tabs = [
        { name: "All", id: 0, },
        { name: "OverNight", id: 1, },
        { name: "Intraday", id: 2, },
        { name: "Non-Visible", id: 3, },
    ];
    //==================== static cities for dropdown ======================
    let cities = [
        { name: "Athens", id: 0 },
        { name: "Mykonos", id: 1 },
        { name: "Corfu", id: 2 },
        { name: "Lefkada", id: 3 },
        { name: "Tinos", id: 4 },
    ];

    // =========== get all inclusive offers data ================
    const get_data = () => {
        let url = allInclusive_API;
        axios.get(url, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': `Token ${userToken}`
            }
        }).then((response) => {
            setLoaded(true)
            let data = response?.data
            if (data?.status !== "error") {
                // console.log(data)
                // setOfferData([...data?.offers])
                setOfferData([...data?.intraday_offers, ...data?.overnight_offers])
            }
        }).catch((err) => {
            console.log("Error ====>", err.message);
            setLoaded(true)
        })
    }
    useEffect(() => {
        get_data()
        return () => {
            get_data()
        }
    }, []);

    // ============ filter data according to selected tab ====================
    useEffect(() => {
        if (offersData?.length > 0) {
            setSearching(false);
            set_searching_intra(false);
            setSearchedData([]);
            set_searchedData_intra([]);
            let filterByOverNight, filterByIntraDay, nonActives = [];
            filterByOverNight = offersData?.filter((val) => val?.overnight === true && val?.available === true);
            filterByIntraDay = offersData?.filter((val) => val?.overnight === false && val?.available === true);
            nonActives = offersData?.filter((val) => val?.available === false);
            // allOffers =  offersData?.filter((val)=> val?.available === true);
            switch (activeTab) {
                case 0:
                    setFiltered(filterByOverNight);
                    setDataIntraday(filterByIntraDay);
                    break;
                case 1:
                    setFiltered(filterByOverNight)
                    break;
                case 2:
                    setFiltered(filterByIntraDay)
                    break;
                case 3:
                    setFiltered(nonActives)
                    break;

            }

        }
    }, [offersData, activeTab]);

    // ============= search offers on input change =============
    const searchData = (e) => {
        let { value } = e.target;
        if (value?.length > 0 && filtered?.length > 0 && loaded) {
            let searched = filtered?.filter((val) => val?.title?.toLowerCase().includes(value?.toLowerCase()));
            let intra_searched = data_intraday?.filter((val) => val?.title?.toLowerCase().includes(value?.toLowerCase()));
            setSearching(true);
            set_searching_intra(true);
            setSearchedData(searched)
            set_searchedData_intra(intra_searched)
        } else {
            setSearching(false);
            set_searching_intra(false);
            setSearchedData([])
            set_searchedData_intra([])
        }
    };

    // ================ Delete An Offer =======================
    const deleteAnOffer = () => {
        // console.log(selectedOffer);
        let url = allInclusive_API + selectedOffer;
        set_loader(true);
        setAskModal(false);
        axios.delete(url, {
            data:{
                id: selectedOffer
            },
            headers: {
                'Authorization': `Token ${userToken}`
            }
        }).then((response) => {
            setLoaded(true)
            let data = response?.data
            if (data?.status !== "error") {
                get_data()
                setSelected(null);
                set_notify({ open: true, msg: "Offer deleted successfully.", type: "success" });
                set_loader(false)
            }
        }).catch((err) => {
            console.log("Error while deleting offer ====>", err.message);
            set_loader(false)
        })
        // setTimeout(() => {
        //     set_notify({ open: true, msg: "Delete Endpoint is currently under development. Thanks for testing :)", type: "info" });
        //     set_loader(false)
        // }, 1000)
    };

    // console.log(selectedOffer);
    // console.log(filtered)
    // console.log(searchedData)
    // console.log(offersData)
    return (
        <div className="py-2">
            {/* Search bar */}
            <div className="bigSearchBarWrapper d-flex justify-content-start align-items-center">
                <span><svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                    <path d="M17 17L13.2223 13.2156L17 17ZM15.3158 8.15789C15.3158 10.0563 14.5617 11.8769 13.2193 13.2193C11.8769 14.5617 10.0563 15.3158 8.15789 15.3158C6.2595 15.3158 4.43886 14.5617 3.0965 13.2193C1.75413 11.8769 1 10.0563 1 8.15789C1 6.2595 1.75413 4.43886 3.0965 3.0965C4.43886 1.75413 6.2595 1 8.15789 1C10.0563 1 11.8769 1.75413 13.2193 3.0965C14.5617 4.43886 15.3158 6.2595 15.3158 8.15789V8.15789Z" stroke="#909090" strokeWidth="2" strokeLinecap="round" />
                </svg>
                </span>
                <input type="Search" placeholder="Search" onChange={searchData} />
            </div>
            {/*  */}
            <h3 className="py-3">All Inclusive</h3>
            {/* tabs btns */}
            <div className="allOffers_tab_btn_wrapper">
                <div className="btns_row">
                    {tabs.map((v, i) => {
                        return (
                            <button className={`${activeTab === v.id ? 'activeTab_btn_cs' : ""} csTabs_btn_ds`} onClick={() => setActiveTab(v.id)} key={i}>
                                {v.name}
                            </button>
                        )
                    })}
                </div>
                <div className="button_area_right d-flex">
                    {/* <div className="cs-select"> */}
                    <select className="cs_select_white" name="" id="" onChange={(e) => setSelectedCity(e.target.value)} value={selectedCity}>
                        <option value={null}>Select City</option>
                        {cities?.map((city, i) => (
                            <option key={i} value={city.id}>{city?.name}</option>
                        ))}
                    </select>
                    {/* </div> */}
                    <Link to="/dashboard/offers/createNew/" className="dark-btn text-white">
                        + &nbsp; Add New
                    </Link>
                </div>
            </div>
            {/* offers according to tab select  all/ overnight/ intraday/ etc*/}
            {loaded ?
                <OffersTabContainer
                    data={filtered}
                    allOffers={activeTab === 0}
                    tabTitle={tabs[activeTab]?.name}
                    data_intraday={data_intraday}
                    searchedData={searchedData}
                    searching={searching}
                    setSelected={setSelected}
                    setAskModal={setAskModal}
                    searchedData_intra={searchedData_intra}
                    searching_intra={searching_intra}
                />
                : <div className="py-5 mt-5"><Loader /></div>}

            {/* ==== ask modal  ==*/}
            <CustomModal
                openPopup={askModal}
                setOpenPopup={setAskModal}>
                <div className="modal-body">
                    <h4>Are you sure you want to delete this offer?</h4>
                    <hr />
                    <p>
                        Note: This will delete permanently and this will not recover once deleted.if you just want to hide the offer you can set this availability none or false.
                    </p>
                    <div className="mt-4 d-flex justify-content-md-end justify-content-start flex-wrap">
                        <button onClick={deleteAnOffer} className="dark-btn book_now_btn mx-2 mt-2">Okay</button>
                        <button onClick={() => { setSelected(null); setAskModal(false) }} className="dark-btn mt-2 delete-btn text-dark bg-gr book_now_btn">Cancel</button>
                    </div>
                </div>
            </CustomModal>
            {loading && <Loader type="fixed" />}
        </div>
    )
};

// Offers Tab accordingly active
const OffersTabContainer = ({ data, allOffers, tabTitle, data_intraday, searching, searchedData, setSelected, setAskModal, searchedData_intra, searching_intra }) => {
    const navigationPrevRef_1 = useRef(null);
    const navigationNextRef_1 = useRef(null);
    const navigationPrevRef_2 = useRef(null);
    const navigationNextRef_2 = useRef(null);
    return (
        <>
            <div className="dashboard_offers_slider_wrapper py-4">
                <div className="w-100 pb-3">
                    <h3>{allOffers ? "OverNight" : tabTitle}</h3>
                </div>
                <div className="alloffers-result-slider-container">
                    <Swiper
                        className="all-offers-res-swiper-container"
                        onBeforeInit={(swiper) => {
                            swiper.params.navigation.prevEl = navigationPrevRef_2.current;
                            swiper.params.navigation.nextEl = navigationNextRef_2.current;
                        }}
                        navigation={{
                            prevEl: navigationPrevRef_2.current,
                            nextEl: navigationNextRef_2.current,
                        }}
                        spaceBetween={15}
                        slidesPerView={4}
                        grabCursor
                        breakpoints={{
                            100: {
                                slidesPerView: 1,
                            },
                            390: {
                                slidesPerView: 1,
                            },
                            768: {
                                slidesPerView: 2,
                            },
                            1350: {
                                slidesPerView: 3,
                            },
                            2550: {
                                slidesPerView: 4,
                            },
                        }}>
                        {searching ? searchedData?.map((val, index) => (
                            <SwiperSlide key={index} className="all-offers-slider-card">
                                <AllofferCard
                                    data={{
                                        admin: true,
                                        tittle: val?.title,
                                        price: val?.price,
                                        viewMoreLink: window.origin + "/OfferDetails/" + val?.offer_id,
                                        bookNowLink: "/confirmBooking/" + val?.offer_id,
                                        amenities: val?.amenities,
                                        extras: val?.extras,
                                        residenceText: val?.brief_description,
                                        users: val?.people,
                                        thumbnail: api_domain + val?.thumbnail,
                                        img1: null,
                                        img2: null,
                                        period: val?.duration + (parseInt(val?.duration) > 1 ? " days" : " day"),
                                        deleteBtn: () => { setAskModal(true); setSelected(val?.offer_id) },
                                        location: val?.location,
                                        itinerary: val?.itinerary,
                                    }}
                                />
                            </SwiperSlide>
                        ))
                            : data?.map((val, index) => (
                                <SwiperSlide key={index} className="all-offers-slider-card">
                                    <AllofferCard
                                        data={{
                                            admin: true,
                                            tittle: val?.title,
                                            price: val?.price,
                                            viewMoreLink: window.origin + "/OfferDetails/" + val?.offer_id,
                                            bookNowLink: "/confirmBooking/" + val?.offer_id,
                                            amenities: val?.amenities,
                                            extras: val?.extras,
                                            residenceText: val?.brief_description,
                                            users: val?.people,
                                            thumbnail: api_domain + val?.thumbnail,
                                            img1: null,
                                            img2: null,
                                            period: val?.duration + (parseInt(val?.duration) > 1 ? " days" : " day"),
                                            deleteBtn: () => { setAskModal(true); setSelected(val?.offer_id) },
                                            location: val?.location,
                                            itinerary: val?.itinerary,
                                        }}
                                    />
                                </SwiperSlide>
                            ))

                        }

                        <div ref={navigationPrevRef_2} className="alloffers-result-slider-cs-nav prev-bt d-flex justify-content-center align-items-center cursor-pointer">
                            <ChevronLeft />
                        </div>
                        <div ref={navigationNextRef_2} className="alloffers-result-slider-cs-nav next-bt d-flex justify-content-center align-items-center cursor-pointer">
                            <ChevronRight />
                        </div>
                    </Swiper>
                </div>
            </div>
            {allOffers &&
                <div className="dashboard_offers_slider_wrapper pb-4">
                    <div className="w-100 pb-3">
                        <h3>Intraday</h3>
                    </div>
                    <div className="alloffers-result-slider-container">
                        <Swiper
                            className="all-offers-res-swiper-container"
                            onBeforeInit={(swiper) => {
                                swiper.params.navigation.prevEl = navigationPrevRef_1.current;
                                swiper.params.navigation.nextEl = navigationNextRef_1.current;
                            }}
                            navigation={{
                                prevEl: navigationPrevRef_1.current,
                                nextEl: navigationNextRef_1.current,
                            }}
                            spaceBetween={15}
                            slidesPerView={4}
                            grabCursor
                            breakpoints={{
                                100: {
                                    slidesPerView: 1,
                                },
                                390: {
                                    slidesPerView: 1,
                                },
                                768: {
                                    slidesPerView: 2,
                                },
                                1350: {
                                    slidesPerView: 3,
                                },
                                2550: {
                                    slidesPerView: 4,
                                },
                            }}>
                            {searching_intra ?
                                searchedData_intra?.map((val, index) => (
                                    <SwiperSlide key={index} className="all-offers-slider-card">
                                        <AllofferCard
                                            data={{
                                                admin: true,
                                                tittle: val?.title,
                                                price: val?.price,
                                                viewMoreLink: window.origin + "/OfferDetails/" + val?.offer_id,
                                                bookNowLink: "/confirmBooking/" + val?.offer_id,
                                                amenities: val?.amenities,
                                                extras: val?.extras,
                                                residenceText: val?.brief_description,
                                                users: val?.people,
                                                thumbnail: api_domain + val?.thumbnail,
                                                img1: null,
                                                img2: null,
                                                period: val?.duration +  (parseInt(val?.duration) > 1 ? " days" : " day"),
                                                deleteBtn: () => { setAskModal(true); setSelected(val?.offer_id) },
                                                location: val?.location,
                                                itinerary: val?.itinerary,
                                            }}
                                        />
                                    </SwiperSlide>
                                ))
                                :
                                data_intraday?.map((val, index) => (
                                    <SwiperSlide key={index} className="all-offers-slider-card">
                                        <AllofferCard
                                            data={{
                                                admin: true,
                                                tittle: val?.title,
                                                price: val?.price,
                                                viewMoreLink: window.origin + "/OfferDetails/" + val?.offer_id,
                                                bookNowLink: "/confirmBooking/" + val?.offer_id,
                                                amenities: val?.amenities,
                                                extras: val?.extras,
                                                residenceText: val?.brief_description,
                                                users: val?.people,
                                                thumbnail: api_domain + val?.thumbnail,
                                                img1: null,
                                                img2: null,
                                                period: val?.duration +  (parseInt(val?.duration) > 1 ? " days" : " day"),
                                                deleteBtn: () => { setAskModal(true); setSelected(val?.offer_id) },
                                                location: val?.location,
                                                itinerary: val?.itinerary,
                                            }}
                                        />
                                    </SwiperSlide>
                                ))
                            }

                            <div ref={navigationPrevRef_1} className="alloffers-result-slider-cs-nav prev-bt d-flex justify-content-center align-items-center cursor-pointer">
                                <ChevronLeft />
                            </div>
                            <div ref={navigationNextRef_1} className="alloffers-result-slider-cs-nav next-bt d-flex justify-content-center align-items-center cursor-pointer">
                                <ChevronRight />
                            </div>
                        </Swiper>
                    </div>
                </div>}
        </>

    )
}

export default AllInCLusivePage
